import { Heading03, HelperText01 } from 'module/ui/components/styles';
import { FC } from 'react';
import styled from 'styled-components';
import { CustomGroupSectionComponentProps } from '../../types';

const Title = styled.div`
  ${Heading03};
`;
const Description = styled.div`
  ${HelperText01};
  color: var(--text-tertiary);
`;
const Wrapper = styled.div`
  padding: var(--spacing-05);
  border-bottom-left-radius: var(--border-radius-small);
  border-bottom-right-radius: var(--border-radius-small);
  border: 1px solid var(--field-border-default);
  border-top: none;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-02);
  cursor: pointer;
`;

interface Props extends CustomGroupSectionComponentProps {
  onWrapperClick: () => void;
}
export const CustomGroupSectionPromptPreview: FC<Props> = ({
  node,
  onWrapperClick,
}) => {
  return (
    <Wrapper onClick={onWrapperClick}>
      <Title>{node.attrs.title}</Title>
      <Description>{node.attrs.config.description}</Description>
    </Wrapper>
  );
};
